import { Input, TextField, useMediaQuery } from '@mui/material';
import React from 'react';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { searchPosts } from '../../actions/posts';
import styles from './styles'; 
import { FiSearch, FiFilter, FiX } from "react-icons/fi";
import './styles.scss'; //Because JSS in react not loving pseudo elements
import theme from '../../muiTheme';
import ChipInput from '../ChipInput/ChipInput';

const useQuery = () => {

    let location = useLocation(); 

    return new URLSearchParams(location.search); 
}

const SearchBar = ({style}) => {

    const [search, setSearch] = useState('');
    const [showSearchButton, setShowSearchButton] = useState(false); 
    const [showFilter, setShowFilter] = useState(false); 
    const [tags, setTags] = useState([]); 
    const dispatch = useDispatch();
    const query = useQuery();  
    const navigate = useNavigate(); 
    const searchQuery = query.get('searchQuery'); 
    const tagsQuery = query.get('tags'); 
    const isMobile = useMediaQuery('(max-width: 768px)');

    useEffect(()=>{

         setShowSearchButton(search.length > 0 || tags.length > 0); 

    }, [search, tags]);

    let iconOpacity = showSearchButton ? 1 : 0; 
    let iconVisiblity = showSearchButton ? 'visible' : 'hidden'; 
    let tagBarVisibility = showFilter ? 'visible' : 'hidden'; 

    const handleSearchChange = (event) => {

        setSearch(event.target.value);
    }

    const handleKeyUp = (event) => {

        if(event.keyCode === 13){
            navSearchPosts(); 
            
        }
    }

    const handleAdd = (tag) => {
        setTags((prevTags)=>[...prevTags, tag]);
    }

    const handleDelete = (tagToDelete) => {

        setTags(tags.filter((tag)=> tag !== tagToDelete));
    }

    
    const navSearchPosts = () => {

        if(search.trim() || tags.length > 0){

            var query = {
                search,
                tags: tags.join(',')
            };

            dispatch(searchPosts(query));
            navigate(`/posts/search?searchQuery=${search || 'none'}&tags=${tags.join(',')}`);
        }else {

            navigate('/');
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault(); 

        //submit search
        navSearchPosts(); 

        //clear search items
        setSearch('');
        setTags([]); 
    }

    const toggleFilter = (event) => {

        event.preventDefault(); 

        setShowFilter((prevValue)=> !prevValue);

    }

    return (
        <form className='rootForm' onSubmit={handleSubmit} style={{...styles.rootForm, boxShadow: showFilter ? '0 0 8px rgba(0,0,0,0.2)' : 'none', ...style}}>

            <div className='mainSearchContainer' style={{...styles.mainContainer, width: isMobile? '100%' : '100%'}}>

                <button className='tagFilter' style={{...styles.tagFilter, backgroundColor: showFilter ? theme.palette.primary.main : theme.palette.lightGray}} onClick={toggleFilter}>
                    <FiFilter style={styles.tagFilterIcon} />
                </button>

                <div style={styles.horizDivider}>

                </div>

                <input
                    name='search' 
                    variant='main' 
                    label='search'
                    placeholder='Search Posts'
                    value={search}
                    onChange={handleSearchChange}
                    onKeyUp={handleKeyUp}
                    style={styles.navSearchBar}
                    className='navSearchBar'
                >
                    
                </input>

                <button className='searchButton' style={{...styles.searchButton, opacity: iconOpacity, visibility: iconVisiblity,     marginLeft: isMobile ? '-20px' : '0px'}}>
                    <FiSearch style={styles.navSearchIcon}/>
                </button>

            </div>
            
            <div className='tagBarContainer' style={{...styles.tagBarContainer, visibility: tagBarVisibility, maxHeight: showFilter ? '400px' : '0px', minHeight: showFilter ? '100px' : '0px', height: 'auto', opacity: showFilter ? 1 : 0, padding: showFilter ? '20px 5px': '0px'}}>

                <ChipInput 
                    onDelete={handleDelete}
                    onAdd={handleAdd}
                    value={tags}
                    label='Filter search by tags'
                    placeholder='search tags'
                    sxTextField={styles.chipInput}
                />

                <button className='filterSearchButton' style={{...styles.filterSearchButton}}>
                    <FiSearch style={styles.navSearchIcon}/>
                    <span style={styles.filterSpan}>
                        Search
                    </span>
                </button>
                
            </div>
            

        </form>
    );
}

export default SearchBar; 